module.exports = __webpack_public_path__ + "img/andy.1711b4b0.gif";